module.exports = __webpack_public_path__ + "ae0ae6273361dd6d51ef387a5bd612db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/list-tobacco-holdings.png
// module id = 1555
// module chunks = 0